import { Component, OnInit, EventEmitter, Output, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../Services/validation.service';
import { UserRegistrationModel } from 'src/app/Models/UserRegistrationModel';
import { UserSetPasswordModel } from 'src/app/Models/UserSetPasswordModel';
import { RestClientService } from 'src/app/Services/restClient.service';
import { EncryptionService } from 'src/app/Services/encryption.service';
import { ActivityIndicatorService } from 'src/app/Services/activityIndicator.service';
import { MatSnackBar, MatStepper } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/constants';
import { RestResponseModel } from 'src/app/Models/RestResponseModel';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  loginForm: FormGroup;
  changePasswordForm: FormGroup;
  passwordControls: any;
  loginControls: any;
  passwordSuccessfullyChanged = false;
  loginSuccessfull = false;
  hidePassword = false;
  hideNewPassword = false;
  hideConfirmNewPassword = false;

  private _payloadValidateCredentials: UserRegistrationModel;
  private _payloadSetPassword: UserSetPasswordModel;


  constructor(private validationService: ValidationService,
    private restClient: RestClientService,
    private encrypt: EncryptionService,
    private activityIndicator: ActivityIndicatorService,
    private _snackBar: MatSnackBar,
    private translate: TranslateService) {
    this._payloadValidateCredentials = new UserRegistrationModel();
    this._payloadSetPassword = new UserSetPasswordModel();

  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      Username: new FormControl('', Validators.required),
      Password: new FormControl('', Validators.required),
    });

    this.loginControls = this.loginForm.controls;

    this.changePasswordForm = new FormGroup({
      Password: new FormControl('', Validators.required),
      ConfirmPassword: new FormControl('', Validators.required),
    },
      {
        validators: this.validationService.Match('Password', 'ConfirmPassword')
      });

    this.passwordControls = this.changePasswordForm.controls;
  }

  public SubmitValidateCredentials() {
    if (this.loginForm.invalid) {
      return;
    }
    this.activityIndicator.ShowLoading(true);
    this._payloadValidateCredentials = this.loginForm.value as UserRegistrationModel;
    this._payloadValidateCredentials.Password = this.encrypt.set(this._payloadValidateCredentials.Password);
    this.restClient
      .Post<UserRegistrationModel, RestResponseModel>(AppConfig.URLValidateCredentials, this._payloadValidateCredentials)
      .subscribe(
        success => {
          this._payloadSetPassword.Username = this._payloadValidateCredentials.Username;
          this._payloadSetPassword.OldPassword = this._payloadValidateCredentials.Password;
          this.loginSuccessfull = true;
          this.stepper.next();
          this.activityIndicator.ShowLoading(false);
        },
        error => {
          const message = this.translate.get('errorMessage'.concat(error.errorMessage.toString()));
          message.subscribe((response) => {
            this._snackBar.open(response, 'Error', { duration: 5000 });
          });
          this.activityIndicator.ShowLoading(false);
        }
      );
  }

  public SubmitSetNewPassword() {
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.activityIndicator.ShowLoading(true);
    this._payloadSetPassword.NewPassword = this.encrypt.set(this.changePasswordForm.get('Password').value);
    this.restClient
      .Post<UserSetPasswordModel, RestResponseModel>(AppConfig.UrlSetPassword, this._payloadSetPassword)
      .subscribe(
        success => {
          this.passwordSuccessfullyChanged = true;
          this.activityIndicator.ShowLoading(false);
        },
        error => {
          const message = this.translate.get('errorMessage'.concat(error.errorMessage.toString()));
          message.subscribe((response) => {
            this._snackBar.open(response, 'Error', { duration: 5000 });
          });
          this.activityIndicator.ShowLoading(false);
        }
      );

  }

}
